// import color from "../../../constants/color";

import color from "../../../../constants/color"


const styles = {

  TableHead: {
    color: "#878787",
    // fontWeight: "600",
    whiteSpace: "nowrap", 
  },

  leaveHeading: { 
    fontWeight: "600",
    fontSize: "20px", 
  },

  tabledata: {
    borderBottom: 0,
    textTransform:"capitalize",
    whiteSpace: "nowrap", 

  },
  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    cursor:"pointer"
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "flex-start", 
    gap: "10px !important",
  },
  editButton: {
    "&.MuiIconButton-root": {
      padding: "4px",
      borderRadius: "12px",
    },
    "&:disabled": {
      opacity: 0.4,
    },
    svg: {
      width: "18px",
      height: "18px",
    }
  },
  dropdown:{
    width: "100%",
    p:0,
    height: "2.5em",

    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
    }
  },
  reason:{
    borderRadius: "8px",

    width:"100%",
    height: "4.5em",},
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  calenderInput:{
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      width:"11.85em"
    }
  },  
  noteInput:{
    height:"4.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"14px"
    },
  },
  calender:{
    borderRadius:"5px",
  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    mb:1
  },
  exportBtn: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "& svg": {
      mr: 1
    }
  },
  inputBox: {
    // Container for company select
  },
  hoursInput: {
    width: "10em",
    borderRadius: "8px",
    height: "2em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",
    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  leaveTypeInput: {
    width: "11em",
    borderRadius: "8px",
    height: "2em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      // padding: "8.5px 14px",
      borderRadius: "8px",
    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  dropDownMenu: {
    fontSize: "12px",
    my: "10px",
    fontWeight: "500",
    width: "100%",
    height: "40px"
  }
}
export default styles
